<template>
  <div id="app" :style="zoomCss"  @click="handleClickRead">
    <bank-header :isBig="isBig" @toggle-big="changeSize"></bank-header>
      <div class="v-view">
          <router-view></router-view>
      </div>
    <bank-footer></bank-footer>
  </div>
</template>

<script>
import BankHeader from './components/BankHeader.vue'
import BankFooter from './components/BankFooter.vue'
import $ from 'jquery'
export default {
  name: 'App',
  components: {
    BankHeader,
    BankFooter,
  },
  data(){
    return {
        isBig: false,
    }
  },
    created () { // 属性已有，结构未渲染
        window.onmessage = e => {
            const { type } = e.data
            switch (type) {
                case 'open':
                    this.$store.commit('UPDATE_EDIT', true)
                    break
                case 'close':
                    this.$store.commit('UPDATE_EDIT', false)
                    break
                case 'reload':
                    setTimeout(() => {
                        this.$store.dispatch('getDecorateInfo')
                    }, 200)
                    break
                default:
                    break
            }
        }
    },
    computed: {
        openEdit () {
            let open = this.$store.getters.openEdit
            if (open) {
                $('a').removeAttr('target')
            }
            return open
        },
        zoomCss () {
            console.log(this.isBig,'-------');
            const scale = this.isBig ? 1.5 : 1
            return {
                transform: `scale(${scale})`,
                transformOrigin: '0 0', //左上角放大
                width: `${ 100 / scale }%`
            }
        },
    },
    methods: {
        changeSize () {
            this.isBig = !this.isBig
            localStorage.setItem('isBig', this.isBig)
        },
        // 核心：点击容器内任意元素触发朗读
        handleClickRead(e) {
            // 如果点读开关关闭，直接返回
            if (localStorage.getItem('voiceSwitch') === 'false') return

            const target = e.target
            const tagName = target.tagName

            // ✅过滤：点击按钮、输入框、选择框等控件，不触发朗读
            const excludeTags = ['BUTTON', 'INPUT', 'SELECT', 'TEXTAREA']
            if (excludeTags.includes(tagName)) return
            function hasRealTextNode(el) {
                // 遍历当前元素的子节点
                for (const node of el.childNodes) {
                    // nodeType ===3 代表Text文本节点
                    if (node.nodeType === 3) {
                        const txt = node.textContent.trim()
                        if (txt.length > 0) {
                            return true
                        }
                    }
                }
                return false
            }
            // 没有直接文字节点 → 点的是空白/容器，直接return
            if (!hasRealTextNode(target)) return

            // 获取点击元素内纯文本，去除前后空格
            const text = target.textContent.trim()
            if (!text || text == '关闭语音播报') return
            console.log(text,target,'text------');
            // 送入播报队列，自动排队播报
            this.$speakEnqueue(text, { rate: 0.9 })
                .catch(err => {
                console.debug('播报失败：', err.message)
                // this.$message.warning('请先开启语音播报')
                })
        }
    },
    mounted () {
        $('body').on('mouseover', '.decorate', e => {
            if (this.openEdit) {
                $(e.target).parents('.decorate').find('#edit-mask:hidden:first').show()
            }
        }).on('mouseout', '.decorate', e => {
            if (this.openEdit) {
                $(e.target).parents('.decorate').find('#edit-mask:first').hide()
            }
        }).on('click', '.decorate .mask-edit-btn', e => {
            const editInfo = $(e.target).attr('editinfo')
            if (this.openEdit && editInfo) {
                window.parent.postMessage({ editInfo: editInfo, router: this.$route.fullPath }, '*')
            }
        })

        this.isBig = localStorage.getItem('isBig') === 'true'
    },
}
</script>

<style lang="scss">
@import '@/style/common/common.scss';
</style>
